import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from '../../contexts/TranslationContext';
import '../../styles/legal.scss';

const TermsOfService: React.FC = () => {
  const { t } = useTranslation();
  const lt = t.legal.terms;

  return (
    <div className="legal-page">
      <Helmet>
        <title>Terms of Service | PhilipSnat</title>
        <meta name="description" content="Read the PhilipSnat Terms of Service governing use of our sports tipster platform." />
        <link rel="canonical" href="https://philipsnat.com/terms-of-service" />
        <meta name="robots" content="noindex" />
      </Helmet>
      <div className="legal-page__container">
        <div className="legal-page__header">
          <h1 className="legal-page__title">{lt.title}</h1>
          <p className="legal-page__updated">{t.legal.lastUpdated.replace('{date}', 'May 4, 2026')}</p>
        </div>

        <section className="legal-page__section">
          <h2 className="legal-page__section-title">{lt.s1Title}</h2>
          <p className="legal-page__text">{lt.s1Text}</p>
          <div className="legal-page__highlight">
            <p className="legal-page__text">
              <strong>{lt.s1Notice}</strong> {lt.s1NoticeText}
            </p>
          </div>
        </section>

        <section className="legal-page__section">
          <h2 className="legal-page__section-title">{lt.s2Title}</h2>
          <p className="legal-page__text">{lt.s2Text1}</p>
          <p className="legal-page__text">{lt.s2Text2}</p>
        </section>

        <section className="legal-page__section">
          <h2 className="legal-page__section-title">{lt.s3Title}</h2>
          <p className="legal-page__text">{lt.s3Text}</p>
        </section>

        <section className="legal-page__section">
          <h2 className="legal-page__section-title">{lt.s4Title}</h2>
          <div className="legal-page__highlight">
            <p className="legal-page__text">{lt.s4Text}</p>
          </div>
        </section>

        <section className="legal-page__section">
          <h2 className="legal-page__section-title">{lt.s5Title}</h2>
          <p className="legal-page__text">{lt.s5Intro}</p>
          <ul className="legal-page__list">
            <li>{lt.s5Item1}</li>
            <li>{lt.s5Item2}</li>
            <li>{lt.s5Item3}</li>
            <li>{lt.s5Item4}</li>
            <li>{lt.s5Item5}</li>
          </ul>
        </section>

        <section className="legal-page__section">
          <h2 className="legal-page__section-title">{lt.s6Title}</h2>
          <p className="legal-page__text">{lt.s6Text}</p>
        </section>

        <section className="legal-page__section">
          <h2 className="legal-page__section-title">{lt.s7Title}</h2>
          <p className="legal-page__text">{lt.s7Text}</p>
        </section>

        <section className="legal-page__section">
          <h2 className="legal-page__section-title">{lt.s8Title}</h2>
          <p className="legal-page__text">{lt.s8Text}</p>
        </section>

        <section className="legal-page__section">
          <h2 className="legal-page__section-title">{lt.s9Title}</h2>
          <p className="legal-page__text">{lt.s9Text}</p>
        </section>
      </div>
    </div>
  );
};

export default TermsOfService;
